<ng-container *ngIf="areSurveyVersionsLoading">
  <div class="loading-cover">
    <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
  </div>
</ng-container>
<ng-container *ngIf="!areSurveyVersionsLoading">

  <table class="table table-sm table-striped">
    <thead>
      <tr>
        <th scope="col">Version #</th>
        <th scope="col">Completed Date</th>
        <th scope="col">Completed By</th>
        <th scope="col">Needs Approval</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let m of surveyVersions!">
        <td>{{ m.surveyVersionId }}</td>
        <td>{{ m.dateCreated! | formatUtcDate }}</td>
        <td><span data-private>{{ m.completedBy }}</span></td>
        <td>
          {{ doesSurveyNeedApproval(m) === false ? 'No' : '' }}
          <ng-container *ngIf="doesSurveyNeedApproval(m) === true">
            <a class="badge rounded-pill text-bg-primary"
              (click)="TakeSurveyModalChild.toggleTakeSurveyModal({surveyVersion: m, survey: survey})">Yes</a>
          </ng-container>
        </td>
        <td><button class=" btn btn-sm btn-link" type="button"
            (click)="TakeSurveyModalChild.toggleTakeSurveyModal({surveyVersion: m, survey: survey})">{{doesSurveyNeedApproval(m)
            === true ? 'Review' : 'Edit'}}</button>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>

<ng-container *ngIf="survey">
  <app-take-survey-modal (reloadParent)="reloadSurveyDetails()" [surveyTypeId]="survey.surveyTypeId!"
    [matterId]="survey.caseId!" [surveyTypeDetails]="survey.surveyType!"></app-take-survey-modal>
</ng-container>